import { render, staticRenderFns } from "./CampaignNotesManualNote.vue?vue&type=template&id=1ed2c010&functional=true"
import script from "./CampaignNotesManualNote.vue?vue&type=script&lang=js"
export * from "./CampaignNotesManualNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.98.0__lodash@4._0ede07508368b0c10a5f63bb0b6a47bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports